import axios from 'axios'
import { setAuthTokens } from 'redux/modules/auth'
import { store } from '../redux/store'
import { getLocale, setLocale } from './localstorage'
import { LOGIN_ROUTE } from 'constants/routes'

let isRefreshing = false
let pendingRequests = []

const processQueue = (newToken) => {
  pendingRequests.forEach((cb) => cb(newToken))
  pendingRequests = []
}

export const refreshAccessToken = async () => {
  const { refresh_token: refreshToken } = store.getState().auth
  if (!refreshToken) return null

  if (isRefreshing) {
    return new Promise((resolve) => {
      pendingRequests.push(resolve)
    })
  }

  isRefreshing = true

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/v2/auth/refresh-token`,
      { refresh_token: refreshToken }
    )
    const { access_token: accessToken, refresh_token: newRefresh } = data
    store.dispatch(
      setAuthTokens({ access_token: accessToken, refresh_token: newRefresh })
    )

    processQueue(accessToken)

    return accessToken
  } catch (err) {
    processQueue(null)
    const locale = getLocale()
    localStorage.clear()
    setLocale(locale)
    window.location.href = LOGIN_ROUTE

    return null
  } finally {
    isRefreshing = false
  }
}

export default refreshAccessToken
